<script>
    export let id;
    export let label;
    export let value;
    export let valido = true;
    export let mensajeDeError = "";
    export let opciones = [];
    export let icono = false;
    export let disabled = false;
    export let vacio = '';
    export let valorVacio = '';

    $: opciones = opciones ? opciones.map(x => x.length ? {valor: x, etiqueta: x} : x) : [];

    let touched = false;
</script>

<style>
    .campo {
        display: flex;
        align-items: center;
        border: 2px solid var(--bordes);
        border-radius: 3px 3px 0 0;
    }

    .icono {
        flex: 0 0 auto;
        background: var(--bordes);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--negro);
        padding: .25rem;
    }

    select {
        border: 0;
        display: flex;
        width: 100%;
        font: inherit;
        padding: 0.25em 1em;
        transition: border-color 0.1s ease-out;
        -webkit-appearance: none;
        line-height: var(--alto-de-linea);
        background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10' width='10' height='10'%3E%3Cpath d='M1 3L5 7L9 3' stroke='%23000' fill='none' stroke-width='2' stroke-linecap='round' /%3E%3C/svg%3E") right 1em center no-repeat;
    }

    label {
        display: block;
        margin-bottom: 0.5rem;
        width: 100%;
    }

    .form-control {
        padding: 0.5rem 0;
        width: 100%;
        margin: 0.25rem 0;
    }

    .invalid {
        border-color: var(--acentos);
    }

    .invalid .icono {
        background: var(--acentos);
    }

    .error-message {
        color: red;
        margin: 0.25rem 0;
    }
</style>

<div class="form-control">
    <label for={id}>{label}</label>
    <div class="campo" class:disabled class:invalid="{!valido && touched}">
        {#if icono}
            <div class="icono">
                <i class="material-icons">{icono}</i>
            </div>
        {/if}

        <select id={id} on:input value={value} {disabled}>
            {#if vacio !== false}
                <option value={valorVacio}>{vacio}</option>
            {/if}

            {#each opciones as {valor, etiqueta}}
                <option value={valor}>{etiqueta}</option>
            {/each}
        </select>
    </div>
    {#if mensajeDeError && !valido && touched}
        <p class="error-message">{mensajeDeError}</p>
    {/if}
</div>
